export function Spinner() {
  return (
    <div
      data-testid="spinner"
      className="h-5 w-5 animate-spin rounded-full border-[3px] border-current border-t-transparent"
    />
  );
}
